import cx from 'classnames';
import { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

import s from './status.module.scss';

export enum EmployeeStatusText {
  VALID = 'Действителен',
  CANCELED = 'Отменен',
  ENDED = 'Завершен',
  BLOCKED = 'Заблокирован',
  UNSET = 'Не задан',
}

export const variantStatus = {
  [EmployeeStatusText.UNSET]: 'Not set',
  [EmployeeStatusText.VALID]: 'Valid',
  [EmployeeStatusText.CANCELED]: 'Canceled',
  [EmployeeStatusText.ENDED]: 'Completed',
  [EmployeeStatusText.BLOCKED]: 'Blocked',
};

export const StatusEmployee = ({
  status,
  style,
}: {
  status?: string;
  style?: CSSProperties;
}) => {
  const { t } = useTranslation();

  const statusText = variantStatus[status as EmployeeStatusText] ?? t('Not set');

  const statusClasses = cx(s['root'], {
    [s['unset']]: status === EmployeeStatusText.UNSET,
    [s['active']]: status === EmployeeStatusText.VALID,
    [s['delete']]: status === EmployeeStatusText.CANCELED,
    [s['completed']]: status === EmployeeStatusText.ENDED,
    [s['blocked']]: status === EmployeeStatusText.BLOCKED,
  });

  return (
    <span className={statusClasses} style={style}>
      {t(statusText)}
    </span>
  );
};
